import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";

import "./style.css";
// import api from "../../config/api";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import fundPricesAction from "../../redux/fundPrices/action";
import TabButton from "../../component/TabButton/TabButton";
import fpIcon from "../../assets/icons/FP.png";
import drIcon from "../../assets/icons/DR.png";
import NewReferral from "./NewReferral";
import MyReferrals from "./MyReferrals";

class RewardSystem extends Component {
  state = {
    currentTab: "new"
  };

  componentDidMount() {
    const { history, setHistory } = this.props;
    setHistory(history);
  }

  render() {
    const { currentTab } = this.state;

    return (
      <Container className="mt-3">
        <div>
          <div className="enrollment-container">
            <Row className="flex1 p-0">
              <Col className="p-0 my-2" md={6} sm={12}>
                <TabButton
                  title="New Referral"
                  icon={fpIcon}
                  tabBtnMainContainerClasses="pr-md-4"
                  tabBtnMainContainerStyles={{ display: "flex", flex: 1 }}
                  tabBtnContainerStyles={{ flex: 1 }}
                  onClick={() => {
                    this.setState({ currentTab: "new" });
                  }}
                  active={currentTab === "new"}
                />
              </Col>
              <Col className="p-0 my-2" md={6} sm={12}>
                <TabButton
                  title="My Referrals"
                  icon={drIcon}
                  tabBtnMainContainerClasses="pr-md-4"
                  tabBtnMainContainerStyles={{ display: "flex", flex: 1 }}
                  tabBtnContainerStyles={{ flex: 1 }}
                  onClick={() => {
                    this.setState({ currentTab: "my" });
                  }}
                  active={currentTab === "my"}
                />
              </Col>
            </Row>
          </div>
          {currentTab === "new" ? <NewReferral /> : <MyReferrals />}
        </div>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  allFunds: state.fundPrices.allFunds
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
  setAllFundsValues: fundPricesAction.setAllFundsValues
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RewardSystem);
